import * as React from 'react';
import { GridHeaderFilterCellProps } from '@mui/x-data-grid-pro/components/headerFiltering/GridHeaderFilterCell';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
import { FilterContext } from '../DataGrid';
import './MultiSelect.scss';

export type SelectOption = string | { label: string; value: string };

const optionValue = (o: SelectOption) => (typeof o === 'string' ? o : o.value);
const optionLabel = (o: SelectOption) => (typeof o === 'string' ? o : o.label);

interface SingleSelectFilterProps extends GridHeaderFilterCellProps {
  optionItems?: SelectOption[];
}

export const SingleSelectFilter = ({ item, optionItems }: SingleSelectFilterProps) => {
  const { values, onChange, disabledFields } = React.useContext(FilterContext);
  const isDisabled = disabledFields?.has(item.field) ?? false;
  const value = values[item.field] ?? '';

  const handleChange = (event: SelectChangeEvent<string>) => {
    const v = event.target.value;
    onChange(item.field, v || undefined);
  };

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();
    onChange(item.field, undefined);
  };

  return (
    <div className={`filter-row${isDisabled ? ' filter-row--disabled' : ''}`}>
      <div className="multiselect-wrapper">
        <Select value={value} onChange={handleChange} displayEmpty disabled={isDisabled}>
          <MenuItem value=''>All</MenuItem>
          {optionItems?.map((opt) => (
            <MenuItem key={optionValue(opt)} value={optionValue(opt)}>
              {optionLabel(opt)}
            </MenuItem>
          ))}
        </Select>
      </div>
      {value !== '' && (
        <IconButton size="small" onClick={handleClear} className="filter-clear-btn" tabIndex={-1}>
          <ClearIcon fontSize="small" />
        </IconButton>
      )}
    </div>
  );
};

export default SingleSelectFilter;
